export const SITE_TITLE = '青途 AI - 大学生成长与职业规划平台'
export const SITE_DESCRIPTION = '青途 AI 帮助大学生找到方向，规划成长，走向未来。'
export const INDEX_ROBOTS = 'index,follow'
export const NOINDEX_ROBOTS = 'noindex,nofollow'

function ensureMetaByName(name) {
  let meta = document.querySelector(`meta[name="${name}"]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', name)
    document.head.appendChild(meta)
  }
  return meta
}

function updateMeta(selector, attribute, value) {
  const meta = document.querySelector(selector)
  if (meta && value) meta.setAttribute(attribute, value)
}

export function setPageMetadata({
  title = SITE_TITLE,
  description = SITE_DESCRIPTION,
  robots = INDEX_ROBOTS,
} = {}) {
  const descriptionMeta = ensureMetaByName('description')
  const robotsMeta = ensureMetaByName('robots')
  const previousTitle = document.title
  const previousDescription = descriptionMeta?.getAttribute('content')
  const previousRobots = robotsMeta?.getAttribute('content')

  document.title = title
  descriptionMeta?.setAttribute('content', description)
  robotsMeta?.setAttribute('content', robots)
  updateMeta('meta[property="og:title"]', 'content', title)
  updateMeta('meta[property="og:description"]', 'content', description)

  return () => {
    document.title = previousTitle
    if (descriptionMeta && previousDescription !== null) {
      descriptionMeta.setAttribute('content', previousDescription)
    }
    if (robotsMeta && previousRobots !== null) {
      robotsMeta.setAttribute('content', previousRobots)
    }
  }
}
